module.exports = __webpack_public_path__ + "static/media/scan-gray.ae482dcc.svg";